import React from 'react';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';

const BlockPossibleBonus = ({formik}) => {
    const classes = useStyles();

    const [possibleBonus, setPossibleBonus] = React.useState(false);

    return (
        <div>
            <BlockTitleGroup setShowBlock={setPossibleBonus} showBlock={possibleBonus} title="Показывать в возможных бонусах" />
            {
                possibleBonus &&
                <>
                    <div className={classes.wrapBlockTextarea}>
                        <div className={classes.wrapTextarea}>
                            <span  className={classes.helper}>Описание бонуса</span>
                            <textarea name="" id="" cols="30" rows="10" value={formik.values.description} onChange={(v) => formik.setFieldValue('description', v.target.value)} className={classes.textarea}>
                            </textarea>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default BlockPossibleBonus;